// src/layouts/commissions/data/commissionsTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));

export default function AccountTableData(Accounts, handleEditClick, getFinancialAccounts) {
  const handleDeletion = async (account) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف العمولة رقم "${account.id}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.delete(
            `https://back.al-balad.sa/albalad/v1.0/accounting/accounts/delete/${account.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف العمولة بنجاح",
        });
        getFinancialAccounts();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };

  /*  const handleActivation = async (account) => {
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.patch(
        `https://back.al-balad.sa/albalad/v1.0/administrator/commissions/${commission.id}/toggle-paid`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة الدفع بنجاح",
        });
        getAllCommissionsWithStores();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  }; */

  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "نشط" : "غير نشط"}
        color={isActive ? "success" : "secondary"}
        variant="gradient"
        size="sm"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "المعرف", accessor: "id", width: "2%", align: "right" },
      { Header: "اسم الحساب", accessor: "name", width: "7%", align: "right" },
      { Header: "كود الحساب", accessor: "code", width: "5%", align: "right" },
      { Header: "نوع الحساب", accessor: "type", width: "10%", align: "right" },
      { Header: "قيمة الحساب", accessor: "balance", align: "right" },
      { Header: "الرصيد الحالي ", accessor: "current_balance", align: "right" },
      { Header: "التاريخ", accessor: "created_at", align: "right" },
      { Header: "حالة الحساب", accessor: "status", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows:
      Accounts &&
      Accounts?.map((account) => ({
        id: (
          <MDTypography variant="button" fontWeight="medium">
            {account?.id}
          </MDTypography>
        ),
        name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.name || "---"}
          </MDTypography>
        ),
        code: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.code || "---"}
          </MDTypography>
        ),
        type: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.type_name || "---"}
          </MDTypography>
        ),

        balance: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.balance || "---"}
          </MDTypography>
        ),
        current_balance: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.current_balance || "---"}
          </MDTypography>
        ),
        created_at: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {account?.created_at
              ? new Date(account?.created_at).toLocaleDateString("ar-EG")
              : "---"}
          </MDTypography>
        ),
        status: <Status isActive={account?.is_active} />,
        action: (
          <MDBox
            display="flex"
            alignItems="center"
            gap={1}
            p={1}
            borderRadius="lg"
            bgcolor="background.paper"
            boxShadow={1}
          >
            {/*   */}
            <IconButton
              aria-label="edit"
              sx={{
                color: "text.main",
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "transform 0.2s",
                },
              }}
              onClick={() => handleEditClick(account)}
            >
              <EditIcon fontSize="medium" />
            </IconButton>

            <IconButton
              aria-label="delete"
              sx={{
                color: "error.main",
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "transform 0.2s",
                },
              }}
              onClick={() => handleDeletion(account)}
            >
              <DeleteIcon fontSize="medium" />
            </IconButton>
          </MDBox>
        ),
      })),
  };
}
